import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'salary/'

const initialState = {
    salarySheet: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getSalary = createAsyncThunk('sal/gs', async (dateData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getSalary', dateData)
        console.log(result.data)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const menuSlice = createSlice({
    name: 'sal',
    initialState,
    reducers: {
        reset: (state) => {
            state.salarySheet = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getSalary.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getSalary.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.salarySheet = action.payload.salarySheet
                if (action.payload.otherData.departments) state.departments = action.payload.otherData.departments
                if (action.payload.otherData.grandTotals) state.grandTotals = action.payload.otherData.grandTotals

            })
            .addCase(getSalary.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.salarySheet = []
            })
    }
})

export const { reset } = menuSlice.actions

export default menuSlice.reducer